<template>
  <v-btn
    :variant="variant"
    :color="color"
    :class="classes"
    :disabled="disabled && !loading"
    :loading="loading"
    :size="size"
    @click="$emit('click')"
  >
    <!-- Slot prepend -->
    <template v-if="$slots.prepend" #prepend>
      <slot name="prepend" />
    </template>

    <!-- Label -->
    <span v-html="label"></span>

    <!-- Slot append -->
    <template v-if="$slots.append" #append>
      <slot name="append" />
    </template>

    <!-- Slot loader -->
    <template #loader>
      <slot name="loader">
        <div class="flex items-center justify-center gap-2 px-2 whitespace-nowrap">
          <v-progress-circular
            indeterminate
            size="16"
            width="2"
            color="currentColor"
          />
          <span v-if="label" v-html="label"></span>
        </div>
      </slot>
    </template>
  </v-btn>
</template>

<script>
export default {
  name: "FormButton",

  props: {
    label: { type: String, required: true },

    // styling
    variant: { type: String },
    classes: { type: [String, Object, Array], default: "capitalize" },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    color: { type: String },
    size: { type: String, default: "default" },
  },

  emits: ["click"],
};
</script>
